import { mainContact } from '../../data/contactInfo';

export function WhatsAppIcon({ className = 'whatsapp-icon' }) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16 3C8.83 3 3 8.83 3 16c0 2.28.6 4.5 1.72 6.46L3.2 28.8l6.49-1.5A12.86 12.86 0 0 0 16 29c7.17 0 13-5.83 13-13S23.17 3 16 3Zm0 23.6c-2.04 0-4.03-.58-5.75-1.66l-.4-.25-3.4.79.8-3.32-.27-.42A10.52 10.52 0 0 1 5.4 16C5.4 10.15 10.15 5.4 16 5.4S26.6 10.15 26.6 16 21.85 26.6 16 26.6Zm5.82-7.93c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.36-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.67 0 1.57 1.15 3.1 1.31 3.31.16.21 2.26 3.45 5.47 4.84.76.33 1.36.53 1.82.68.76.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z"
      />
    </svg>
  );
}

function WhatsAppLink({
  className = 'whatsapp-contact-link',
  children,
  showIcon = true,
  showText = true,
  ariaLabel = `Chat on WhatsApp at ${mainContact.whatsappDisplay}`,
}) {
  return (
    <a
      className={className}
      href={mainContact.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      {showIcon && <WhatsAppIcon />}
      {showText && (children || mainContact.whatsappDisplay)}
    </a>
  );
}

export default WhatsAppLink;
